import React, { Fragment, useContext } from "react";
import { Grid, FormHelperText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import CampaignContext from "../../../../context/campaign/CampaignContext";

// Components
import TabReviewsList from "./TabReviewsList";

const useStyles = makeStyles((theme) => ({
  paper: {
    border: `1px solid ${theme.palette.divider}`,
  },
  button: {
    "&:focus": {
      outline: "none",
    },
    textTransform: "none",
    padding: "2px 10px",
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: theme.spacing(1, 0.5),
  },
  section: {
    width: "100%",
    height: "100%",
    maxHeight: 300,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    margin: "auto",
    marginTop: "0.2rem",
    borderRadius: 5,
  },
}));

const TabReviews = () => {
  const classes = useStyles();

  const { checkout_error } = useContext(CampaignContext);

  return (
    <Fragment>
      {/* Text */}
      <Grid item xs={12}>
        <FormHelperText margin="dense" error>
          <strong> {checkout_error.reviews} </strong>
        </FormHelperText>
      </Grid>
      {/* Reviews */}
      <Grid item xs={12} className={classes.section}>
        <TabReviewsList />
      </Grid>
    </Fragment>
  );
};

export default TabReviews;
